import axios from 'axios';

/**
 * Pre-configured Axios instance for unauthenticated (public) API calls.
 *
 * Unlike the main `apiClient`, this instance does NOT attach Cognito tokens
 * or handle 401 refresh flows. It is intended for public endpoints such as
 * the contact form submission (`/public/contact`).
 */
const publicClient = axios.create({
  baseURL: import.meta.env.VITE_PUBLIC_API_URL || import.meta.env.VITE_API_URL || '',
  headers: { 'Content-Type': 'application/json' },
  timeout: 5000,
});

export default publicClient;
